export default __webpack_public_path__ + "/dist/images/member-active.cff4144d08b8b28e6af6e5ee6141a142.svg";